import React from "react";

/**
 * Итог пробной отправки объявления в чат.
 *
 * Главное здесь — не «отправлено», а «увидит ли он это». Чат от профиля Jerm
 * умеет не всякая сборка приложения, и зелёная надпись на телефоне, который
 * такого чата не показывает, была бы враньём: проба ровно для того и нужна,
 * чтобы это всплыло до массовой отправки.
 *
 * Отзывается проба тем же способом, что и настоящая рассылка, — она и есть
 * настоящая строка рассылки, просто с одним получателем.
 */

const STATUS_CLASS = {
	visible: "is-ok",
	outdated_app: "is-error",
	unknown: "is-warn",
};

const STATUS_TEXT = {
	visible:
		"Объявление уже лежит в чате от профиля Jerm у этого человека — откройте приложение или веб под его учётной записью и посмотрите, как оно выглядит.",
	outdated_app:
		"Этот человек объявления не увидит: все его сборки приложения старее минимальной, а браузером он не пользуется. Чата от профиля Jerm в таких сборках просто нет.",
	unknown:
		"Увидит ли он объявление, заранее сказать нельзя: ни зарегистрированного устройства, ни подписки браузера у него нет. Объявление уже лежит в чате и дождётся его входа.",
};

const AppTestResult = ({ result, onWithdraw, isWithdrawing, withdrawn }) => {
	if (!result) return null;

	const versions = Array.isArray(result.appVersions) ? result.appVersions : [];

	return (
		<div className="broadcasts-page__result">
			<p
				className={`broadcasts-page__status ${
					STATUS_CLASS[result.status] || "is-warn"
				}`}
				style={{ marginTop: 0 }}
			>
				Пользователь {result.userId}.{" "}
				{STATUS_TEXT[result.status] ||
					`Статус: ${result.status || "неизвестен"}.`}
			</p>

			{/* Версии сборок — не украшение: без них «не увидит» выглядит приговором
			    без объяснения, и проверять начинают не то. */}
			{(versions.length > 0 || result.web) && (
				<p className="broadcasts-page__hint" style={{ margin: "6px 0 0" }}>
					{versions.length > 0
						? `Сборки приложения: ${versions.join(", ")}. Чат рассылки есть начиная с ${result.minAppVersion}.`
						: ""}
					{result.web
						? " Подписка браузера есть — веб такой чат показывает всегда."
						: ""}
				</p>
			)}

			<p className="broadcasts-page__hint" style={{ margin: "6px 0 0" }}>
				Это настоящее объявление №{result.broadcastId} — оно рисуется тем же
				кодом, что и массовая рассылка. В историю рассылок и в её счётчики проба
				не попадает.
			</p>

			{withdrawn ? (
				<p className="broadcasts-page__status is-ok" style={{ margin: "8px 0 0" }}>
					Проба отозвана — из чата она исчезла.
				</p>
			) : (
				<div className="broadcasts-page__row" style={{ marginTop: 10 }}>
					<button
						type="button"
						className="broadcasts-page__button--secondary"
						disabled={isWithdrawing}
						onClick={onWithdraw}
					>
						{isWithdrawing ? "Отзываем..." : "Отозвать пробу из чата"}
					</button>
					<p className="broadcasts-page__hint broadcasts-page__hint--beside">
						Пока проба не отозвана, она так и лежит у этого человека в чате.
					</p>
				</div>
			)}
		</div>
	);
};

export default AppTestResult;
